// extracted by mini-css-extract-plugin
export var externalLinkIcon = "_p9-5";
export var filledCircle = "_p9-4";
export var historyEntry = "_p9-3";
export var messageSideLeft = "_p9-1";
export var messageSideRight = "_p9-2";
export var orderTrackingCarouselWrapper = "_p9-6";
export var orderTrackingInfoContainer = "_p9-0";